export default "__VITE_ASSET__BXdnOaPx__"